<template>
  <div>
    <h5>
      {{ title }}
    </h5>
    <div>
      <b-spinner
        v-if="loading"
        small
        variant="primary"
      />
    </div>
    <div v-if="!loading">
      <div v-if="groups.length == 0">
        <span class="lead collapse-title ml-5">
          Usuario no cuenta con información
        </span>
      </div>
      <div v-if="groups.length > 0">
        <b-table
          hover
          responsive
          :fields="groupTableFields"
          :items="groups"
          thead-tr-class="d-none"
        >
          <template #cell(esLider)="row">
            <div class="row justify-content-end">
              <vs-chip
                v-tooltip="'Lider'"
                color="success"
                transparent
                v-if="row.item.esLider === 'Y'"
              >
                lider
              </vs-chip>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupsList',
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('Management', [
      'groupTableFields'
    ]),
  },
};
</script>

<style scoped>
</style>
